<template>
  <div class="mr-4">
    <SelectField
      label=""
      placeholder="Sorteringsordning"
      :floatingLabel="false"
      :options="config.sortOptions"
      v-model="value__"
      @input="change()"
      @update:modelValue="change"
      size="md"
    />
  </div>
</template>
<script>
import SelectField from '@/components/ui/form/select';
import { mapGetters } from 'vuex';

export default {
  components: { SelectField },
  props: {
    sortBy: {
      type: Object,
    },
    value: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      /**
       * Inskickat prop får inte manipuleras. Därför klonas den (eller va gör data() med den?)
       */
      value__: {
        label: 'Senast publicerad först',
        value: 'publishedFromTsDesc',
        table: 'publishedFromTs',
        sortorder: 'desc',
      },
    };
  },
  computed: {
    ...mapGetters(['config']),
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     */
    value: {
      handler() {
        this.value__ = this.value;
      },
    },
  },
  methods: {
    change() {
      this.$emit('update:modelValue', this.value__);
    },
  },
};
</script>
